import React from 'react';
import styled from 'styled-components';

const BadgeStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5em;

  position: absolute;
  right: 0.1875em;
  top: 0.25em;

  div {
    display: flex;
    height: 1em;
    /* min-width: 1em; */
    padding: 0.1em 0.35em;
    justify-content: center;
    align-items: center;

    border-radius: 62.5em;
    background: var(--color-extended-hot-pink, #d80c86);

    color: var(--color-text-on-accent-default, #fff);
    text-align: center;

    /* Bold/text-preset-7--bold */
    font-size: 0.7em;
    font-style: normal;
    /* font-weight: 700; */
    /* line-height: 1.125em; /* 150% */
  }
`;

const Badge = ({ content }: { content: string | number }) => {
  if (!content) return null;
  return (
    <BadgeStyled>
      <div>
        <span>{content}</span>
      </div>
    </BadgeStyled>
  );
};

export default Badge;
